/* 糜竺（字子仲） */
import { defineHero, P } from '../define.ts';

export default defineHero({
  id: 'mizhu', name: '糜竺', sub: '字子仲', faction: 'shu', role: '法師/輔助', weapon: 'staff',
  look: { head: 'guan', robe: true, beard: 'goatee', fx: '#ffd46b', c: { cloth: '#6a5a2a', sleeve: '#6a5a2a', armor: '#e9c46a', pole: '#6b4a2a' } },
  skills: [
    ['炸藥桶', 'trap', '埋下炸藥桶，敵人經過時引爆，造成 {200/250/325/400} 傷害。', { x: { k: 'zone', r: 160, dur: 120, mine: [200, 250, 325, 400], trig: 70 }, aim: P(300, 160), cd: [25, 20, 15, 12], mp: [125, 150, 175, 200] }],
    ['自爆部隊', 'command', '呼叫敢死隊 8 秒內接連在敵人身邊自爆，每個造成 {15/25/35/45} 傷害；每名敵人只有第一下會被炸得硬直。', { x: { k: 'meteor', n: 40, gap: 0.2, area: 300, r: 80, dmg: [15, 25, 35, 45], fx: 'fire', seek: true, stagger1: true }, aim: P(400, 300), cd: 15, mp: [100, 120, 140, 160] }],
    ['同歸於盡', 'passive', '陣亡時引爆身上所有炸藥，對周圍敵人最多造成 {350/450/650/850} 傷害。', { pv: { boom: { dmg: [350, 450, 650, 850], r: 320 } } }],
    ['引線地雷', 'trap', '埋下大型炸藥桶 180 秒，敵將靠近時引爆，造成 {250/350/450} 範圍傷害。', { x: { k: 'zone', r: 200, dur: 180, mine: [250, 350, 450], trig: 110, heroOnly: true }, aim: P(300, 200), cd: 25, mp: [200, 250, 300], el: 'fire' }],
  ],
});
